import * as React from "react";

const ComingSoonIcon = (props) => (
  <svg
    width={562}
    height={547}
    viewBox="0 0 562 547"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M83.544 314.2H69.336V316.84H74.88V331H77.976V316.84H83.544V314.2ZM94.3179 318.184L90.2619 327.664L86.2299 318.184H83.1099L88.7019 331.048L88.4859 331.552C87.9099 332.824 87.2859 333.328 86.2299 333.328C85.4139 333.328 84.5979 332.992 84.0219 332.44L82.8219 334.648C83.6379 335.392 84.9819 335.824 86.2539 335.824C88.3899 335.824 90.0219 334.936 91.1979 332.032L97.1979 318.184H94.3179ZM99.2816 331H102.282V325.936H108.738V331H111.738V318.184H108.738V323.392H102.282V318.184H99.2816V331ZM131.607 318.184L127.551 327.664L123.519 318.184H120.399L125.991 331.048L125.775 331.552C125.199 332.824 124.575 333.328 123.519 333.328C122.703 333.328 121.887 332.992 121.311 332.44L120.111 334.648C120.927 335.392 122.271 335.824 123.543 335.824C125.679 335.824 127.311 334.936 128.487 332.032L134.487 318.184H131.607ZM147.558 328.456V318.184H136.998L136.83 322.576C136.686 325.576 136.374 328.384 134.574 328.456H133.974V333.856H136.758V331H146.646V333.856H149.454V328.456H147.558ZM139.566 322.792L139.638 320.728H144.558V328.456H138.246C139.278 327.472 139.47 325.192 139.566 322.792ZM156.909 318.04C154.845 318.04 152.853 318.568 151.485 319.624L152.661 321.808C153.621 321.016 155.109 320.536 156.549 320.536C158.685 320.536 159.741 321.568 159.741 323.32V323.512H156.429C152.541 323.512 151.101 325.192 151.101 327.328C151.101 329.56 152.949 331.168 155.877 331.168C157.797 331.168 159.189 330.544 159.909 329.44V331H162.741V323.488C162.741 319.792 160.605 318.04 156.909 318.04ZM156.501 328.984C154.965 328.984 154.053 328.288 154.053 327.208C154.053 326.272 154.605 325.504 156.645 325.504H159.741V326.992C159.237 328.312 157.965 328.984 156.501 328.984ZM177.854 331L172.838 324.448L177.638 318.184H174.398L171.254 322.384L168.11 318.184H164.774L169.55 324.496L164.558 331H167.87L171.182 326.56L174.47 331H177.854ZM189.84 318.184H180V331H183V320.728H189.84V318.184ZM204.262 318.184H201.382L197.278 327.688L193.294 318.184H190.174L195.694 331.12V335.656H198.718V331.072L204.262 318.184ZM212.56 316.672C215.128 316.672 216.544 315.472 216.592 313.144H214.552C214.528 314.296 213.76 315.016 212.536 315.016C211.288 315.016 210.568 314.296 210.544 313.144H208.552C208.576 315.472 209.992 316.672 212.56 316.672ZM206.344 331H209.104L216.16 322.552V331H219.16V318.184H216.424L209.344 326.632V318.184H206.344V331ZM224.108 331.168C225.188 331.168 226.076 330.328 226.076 329.176C226.076 327.976 225.188 327.184 224.108 327.184C223.028 327.184 222.14 327.976 222.14 329.176C222.14 330.328 223.028 331.168 224.108 331.168ZM229.967 331.168C231.047 331.168 231.935 330.328 231.935 329.176C231.935 327.976 231.047 327.184 229.967 327.184C228.887 327.184 227.999 327.976 227.999 329.176C227.999 330.328 228.887 331.168 229.967 331.168ZM235.826 331.168C236.906 331.168 237.794 330.328 237.794 329.176C237.794 327.976 236.906 327.184 235.826 327.184C234.746 327.184 233.858 327.976 233.858 329.176C233.858 330.328 234.746 331.168 235.826 331.168Z"
      fill="#3E2FA0"
    />
    <g opacity={0.2} filter="url(#filter0_d_0_1)">
      <path
        d="M154.841 526.792C215.812 538.898 334.824 536.524 393.299 526.792C425.867 521.371 504.644 515.206 538.32 452.657C553.261 424.925 517.878 389.505 531.544 335.388C565.87 199.448 551.121 166.201 549.287 109.639C548.166 74.8332 522.552 32.8935 489.373 20.5631C385.364 -18.0696 173.016 3.88645 65.7722 35.9761C-17.2081 60.8021 -5.23552 134.253 13.9588 171.055C60.1934 259.67 24.0082 355.195 12.8762 415.394C-0.00069046 485.089 84.9665 512.915 154.828 526.78L154.841 526.792Z"
        fill="#66ACFF"
      />
      <path
        d="M65.9155 36.4551L65.7722 35.9761L65.9155 36.4551C119.492 20.4238 199.351 6.91726 278.815 2.24786C358.294 -2.42242 437.296 1.75333 489.199 21.0318C505.66 27.1493 520.282 40.6301 530.933 56.9461C541.583 73.2606 548.23 92.3595 548.787 109.655C549.163 121.257 550.082 131.881 551.009 142.595C551.213 144.955 551.418 147.319 551.617 149.699C552.721 162.889 553.662 176.577 553.475 192.741C553.102 225.065 548.216 267.322 531.06 335.266C524.192 362.459 529.655 384.951 534.928 404.05C535.241 405.183 535.553 406.304 535.862 407.412C538.158 415.659 540.268 423.236 541.146 430.306C542.141 438.31 541.549 445.609 537.88 452.42C521.121 483.547 493.134 500.663 465.225 510.677C442.282 518.909 419.441 522.327 402.971 524.791C399.399 525.325 396.126 525.815 393.217 526.299C364.016 531.159 319.673 534.185 275.003 534.482C230.397 534.778 185.51 532.352 155.077 526.329L155.064 526.318L154.925 526.29C120.004 519.359 81.3713 508.949 53.0867 491.597C38.9487 482.923 27.4246 472.532 20.2331 460.002C13.0478 447.482 10.1694 432.796 13.3679 415.485C15.2836 405.125 17.9409 393.723 20.795 381.477C22.0836 375.948 23.4124 370.246 24.7312 364.391C28.968 345.579 33.0947 325.204 35.427 303.935C40.0917 261.395 37.5815 215.25 14.4022 170.824C4.83804 152.486 -2.91121 125.039 2.04113 99.1182C6.98366 73.2486 24.5906 48.8186 65.9155 36.4551Z"
        stroke="#605E5C"
      />
    </g>
    <path
      d="M368.472 489.001C436.664 489.001 491.945 479.332 491.945 467.405C491.945 455.478 436.664 445.809 368.472 445.809C300.28 445.809 244.999 455.478 244.999 467.405C244.999 479.332 300.28 489.001 368.472 489.001Z"
      fill="#D1D3D4"
    />
    <path
      d="M376.344 464.519C376.586 458.184 359.134 452.373 337.364 451.541C315.594 450.708 297.749 455.169 297.507 461.504C297.264 467.84 314.716 473.65 336.487 474.483C358.257 475.316 376.102 470.855 376.344 464.519Z"
      fill="#939598"
    />
    <path
      d="M451.094 469.731C452.486 462.976 434.508 453.564 410.94 448.709C387.373 443.854 367.139 445.395 365.747 452.15C364.356 458.905 382.333 468.317 405.901 473.171C429.469 478.026 449.703 476.486 451.094 469.731Z"
      fill="#939598"
    />
    <path
      d="M479.568 439.847L467.8 426.029L439.156 419.281L430.868 407.392C429.549 407.613 428.076 407.159 427.112 406.239L423.455 402.638C422.447 401.663 420.906 401.175 419.499 401.375L406.812 403.735C404.762 404.023 402.557 402.893 401.859 401.187L399.543 395.558L395.354 396.089C395.354 396.089 382.39 420.179 386.091 437.154C389.504 452.833 396.351 459.714 404.163 463.914C411.122 467.659 421.638 472.601 434.325 473.133C448.42 473.72 463.767 462.706 469.263 455.936C475.413 448.346 479.579 439.869 479.579 439.869L479.568 439.847Z"
      fill="#F8DBAE"
      stroke="#895B3D"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
    <path
      d="M466.573 455.69C469.456 454.049 470.769 450.921 469.507 448.703C468.244 446.486 464.884 446.018 462.001 447.659C459.119 449.3 457.805 452.428 459.068 454.645C460.33 456.863 463.691 457.331 466.573 455.69Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M400.663 428.943C404.026 427.663 405.466 423.245 403.878 419.076C402.291 414.906 398.278 412.564 394.915 413.844C391.552 415.124 390.113 419.542 391.7 423.711C393.287 427.881 397.3 430.223 400.663 428.943Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M452.778 450.962C454.761 449.833 455.665 447.68 454.796 446.154C453.927 444.628 451.615 444.306 449.631 445.435C447.647 446.564 446.743 448.717 447.612 450.243C448.481 451.77 450.794 452.092 452.778 450.962Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M438.381 424.722C443.301 426.008 448.265 427.105 453.251 428.069C457.628 428.911 462.149 429.841 466.626 429.886C468.41 429.908 468.41 427.138 466.626 427.116C462.26 427.071 457.861 426.152 453.595 425.321C448.741 424.379 443.91 423.304 439.123 422.052C437.395 421.598 436.663 424.268 438.392 424.722H438.381Z"
      fill="#C88758"
    />
    <path
      d="M403.275 459.816C404.25 458.888 403.885 456.92 402.459 455.422C401.032 453.924 399.086 453.462 398.111 454.39C397.135 455.319 397.501 457.286 398.927 458.784C400.354 460.282 402.3 460.744 403.275 459.816Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      opacity={0.25}
      d="M477.407 442.162C477.407 442.162 451.578 464.811 440.298 466.274C427.932 467.869 419.887 465.797 414.103 464.368C408.319 462.938 398.147 459.016 398.147 459.016C403.332 463.958 422.125 472.689 436.253 472.412C444.531 472.246 459.157 465.675 464.553 460.645C471.102 454.539 477.407 442.162 477.407 442.162Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M395.66 450.114C396.148 449.65 395.965 448.667 395.252 447.918C394.539 447.169 393.565 446.938 393.078 447.402C392.59 447.866 392.773 448.849 393.486 449.599C394.199 450.348 395.173 450.579 395.66 450.114Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <path
      d="M459.322 446.806C460.043 446.228 460.242 445.28 459.768 444.688C459.293 444.096 458.324 444.084 457.603 444.662C456.882 445.24 456.682 446.189 457.157 446.781C457.631 447.373 458.601 447.384 459.322 446.806Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <path
      d="M401.097 452.261C401.585 451.797 401.402 450.813 400.689 450.064C399.976 449.315 399.002 449.084 398.515 449.548C398.027 450.012 398.21 450.996 398.923 451.745C399.636 452.494 400.609 452.725 401.097 452.261Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <path
      d="M401.548 414.595C392.285 439.947 376.495 463.472 345.579 463.472C314.664 463.472 293.323 439.116 293.323 412.124C293.323 385.132 314.664 365.729 345.579 365.729C358.5 365.729 368.217 366.915 379.542 368.622C383.73 369.253 404.917 374.926 408.119 378.86C408.119 378.86 405.371 404.168 401.559 414.606L401.548 414.595Z"
      fill="#B29876"
      stroke="#895B3D"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
    <path
      d="M270.585 341.419C269.477 340.477 270.175 339.723 271.084 338.493C271.981 337.275 272.635 336.477 273.743 337.419C274.851 338.36 276.214 340.931 275.228 342.084C274.242 343.236 271.693 342.361 270.585 341.408V341.419Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M274.164 336.809C273.643 335.856 274.33 335.513 275.294 334.903C276.247 334.294 276.923 333.906 277.444 334.859C277.965 335.812 278.231 337.972 277.233 338.515C276.236 339.058 274.685 337.762 274.164 336.809Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M384.24 356.942C382.877 358.272 378.8 362.504 377.525 365.075C376.251 367.646 380.838 376.111 382.8 378.715C384.794 381.375 386.623 382.715 389.891 382.538C393.16 382.361 395.531 378.35 399.354 372.721C403.177 367.081 402.446 360.532 400.44 354.892C398.435 349.252 384.628 337.374 381.525 335.058C376.162 331.069 359.153 325.24 359.153 325.24H330.776C330.776 325.24 314.11 331.069 308.404 335.058C305.722 336.93 298.442 342.714 294.132 346.371C293.456 346.947 293.445 346.67 292.968 346.327L283.837 337.75C275.749 328.864 265.277 346.26 269.388 351.69C271.593 354.593 274.929 357.385 277.81 359.335C282.475 362.515 287.793 366.261 291.683 366.737C294.663 367.103 299.162 365.286 301.301 363.535C303.295 361.906 306.741 358.682 306.741 358.682L321.202 346.349C321.202 346.349 316.182 353.319 311.362 362.515C310.309 364.532 307.074 371.834 305.212 379.657C304.869 381.12 304.204 386.727 304.647 391.635C306.653 413.641 308.891 413.63 308.836 414.738C308.78 415.802 308.658 437.841 308.658 437.841C308.658 437.841 307.572 444.933 317.39 446.573C327.208 448.213 337.213 447.482 338.676 444.567C340.139 441.653 339.95 431.47 338.676 428.201C337.402 424.933 337.036 414.373 337.036 414.373L335.031 412.19C335.031 412.19 340.261 415.348 345.203 415.137C350.145 414.927 355.763 412.19 355.763 412.19L353.757 414.373C353.757 414.373 353.391 424.921 352.117 428.201C350.843 431.481 350.666 441.664 352.117 444.567C353.569 447.482 363.575 448.202 373.403 446.573C383.221 444.933 382.135 437.841 382.135 437.841C382.135 437.841 382.013 415.846 381.958 414.738C381.902 413.63 384.14 413.652 386.146 391.635C386.434 388.466 386.334 385.064 385.936 381.906C385.902 381.629 385.082 381.208 384.329 380.488C383.531 379.735 382.8 378.704 382.8 378.704C379.431 372.843 376.517 367.768 377.525 365.064C378.002 363.79 379.553 362.593 378.977 361.441C374.489 352.487 369.591 346.338 369.591 346.338L383.188 357.607L384.24 356.931V356.942Z"
      fill="#CCCCF2"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M330.377 324.664L318.975 329.983C316.182 331.28 312.902 330.914 310.476 329.03C310.476 329.03 304.869 324.31 302.786 323.047C299.894 321.285 294.309 318.825 289.777 319.257C287.195 319.501 281.389 320.686 280.303 315.002C279.294 309.706 278.774 299.678 277.699 293.838C276.546 287.622 269.721 277.616 267.704 274.237C266.02 271.411 266.474 268.53 268.07 266.447C270.142 263.743 276.125 255.998 278.951 248.962C281.61 242.335 284.957 232.463 285.267 224.219C285.389 220.972 285.777 217.227 289.367 216.706C292.957 216.185 307.672 214.833 314.409 211.609C324.592 206.745 331.163 202.201 335.95 195.886C340.726 189.57 344.992 187.52 351.652 193.836C358.311 200.152 362.212 206.745 371.276 211.066C380.528 215.487 390.39 217.038 396.529 216.529C398.678 216.351 400.385 216.983 401.703 217.892C403.886 219.388 405.183 221.892 405.404 224.529C405.759 228.74 407.332 237.261 408.474 241.892C410.025 248.219 414.036 258.823 418.203 262.17C421.538 264.84 422.602 266.425 422.136 270.547C421.671 274.613 415.222 284.774 412.984 290.315C410.801 295.711 410.014 306.293 410.081 312.553C410.125 317.551 408.995 321.717 403.831 320.842C397.005 319.678 391.531 320.819 386.955 325.218C380.728 331.202 378.977 333.13 374.323 332.31C369.669 331.49 360.671 324.332 360.671 324.332L330.399 324.687L330.377 324.664Z"
      fill="#CCCCF2"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M367.652 374.073V357.397C367.652 354.682 366.19 352.145 363.863 350.793L349.402 342.449C347.042 341.064 344.117 341.064 341.79 342.416L327.296 350.793C324.969 352.145 323.507 354.649 323.507 357.397V374.073C323.507 376.788 324.969 379.326 327.296 380.677L341.757 389.021C344.117 390.373 347.009 390.373 349.369 389.021L363.829 380.677C366.19 379.326 367.652 376.821 367.652 374.073Z"
      fill="#533FD7"
    />
    <path
      d="M356.461 367.093C356.461 373.276 351.353 378.251 345.136 377.974C339.507 377.73 334.953 373.176 334.709 367.547C334.676 366.993 334.709 366.439 334.776 365.918C334.92 364.633 336.515 364.079 337.38 365.054C339.363 367.347 342.311 368.81 345.613 368.81C348.915 368.81 351.829 367.347 353.846 365.054C354.71 364.079 356.317 364.633 356.45 365.918V367.104L356.461 367.093Z"
      fill="white"
    />
    <path
      d="M346.854 194.988C347.74 194.988 347.751 193.603 346.854 193.603C345.956 193.603 345.956 194.988 346.854 194.988Z"
      fill="#E8E8F7"
    />
    <path
      d="M348.937 197.714C350.976 200.794 353.502 203.542 356.206 206.035C359.131 208.739 362.334 211.199 365.835 213.093C366.622 213.515 367.32 212.318 366.533 211.897C363.12 210.057 360.029 207.675 357.181 205.049C354.566 202.633 352.095 199.985 350.123 197.004C349.635 196.262 348.438 196.96 348.926 197.703L348.937 197.714Z"
      fill="#E8E8F7"
    />
    <path
      d="M290.176 226.246C291.062 226.246 291.073 224.861 290.176 224.861C289.278 224.861 289.278 226.246 290.176 226.246Z"
      fill="#E8E8F7"
    />
    <path
      d="M288.203 231.233C287.527 235.488 286.652 239.71 285.123 243.754C283.162 248.962 280.236 253.749 277.089 258.314C276.58 259.045 277.787 259.743 278.286 259.012C281.433 254.436 284.325 249.649 286.331 244.452C287.926 240.308 288.846 235.975 289.533 231.599C289.666 230.723 288.336 230.346 288.192 231.233H288.203Z"
      fill="#E8E8F7"
    />
    <path
      d="M275.749 281.905C276.635 281.905 276.646 280.52 275.749 280.52C274.851 280.52 274.851 281.905 275.749 281.905Z"
      fill="#E8E8F7"
    />
    <path
      d="M278.197 285.76C279.76 287.478 280.679 289.816 281.333 292.032C283.106 298.049 283.261 304.487 283.106 310.714C283.084 311.6 284.469 311.6 284.491 310.714C284.657 304.309 284.491 297.639 282.608 291.456C281.887 289.074 280.879 286.647 279.184 284.785C278.585 284.121 277.61 285.107 278.208 285.76H278.197Z"
      fill="#E8E8F7"
    />
    <path
      d="M412.862 281.062C410.225 284.818 408.341 289.073 407.332 293.539C407.133 294.403 408.474 294.78 408.673 293.904C409.659 289.539 411.488 285.417 414.058 281.76C414.568 281.029 413.371 280.342 412.862 281.062Z"
      fill="#E8E8F7"
    />
    <path
      d="M297.5 348.034C298.154 347.203 299.096 346.56 299.938 345.939C301.334 344.898 302.774 343.912 304.215 342.925C307.185 340.909 310.199 338.97 313.146 336.931C313.877 336.421 313.179 335.224 312.448 335.734C309.445 337.817 306.365 339.79 303.351 341.851C301.899 342.837 300.448 343.834 299.051 344.887C298.187 345.54 297.201 346.194 296.525 347.059C295.982 347.746 296.957 348.743 297.5 348.034Z"
      fill="#E8E8F7"
    />
    <path
      d="M315.75 333.939C315.672 333.983 315.606 334.038 315.551 334.116C315.484 334.182 315.451 334.26 315.429 334.349C315.395 334.437 315.395 334.537 315.418 334.626C315.418 334.714 315.451 334.803 315.495 334.88L315.606 335.025C315.695 335.113 315.794 335.169 315.916 335.202L316.105 335.224C316.227 335.224 316.348 335.191 316.459 335.124C316.537 335.08 316.603 335.024 316.659 334.947C316.725 334.88 316.758 334.803 316.781 334.714C316.814 334.626 316.814 334.526 316.792 334.437C316.792 334.349 316.758 334.26 316.714 334.182L316.603 334.038C316.515 333.95 316.415 333.894 316.293 333.861L316.105 333.839C315.983 333.839 315.861 333.872 315.75 333.939Z"
      fill="#E8E8F7"
    />
    <path
      d="M372.971 359.369L374.29 361.33C374.389 361.485 374.522 361.596 374.7 361.651C374.866 361.696 375.087 361.674 375.232 361.585C375.531 361.396 375.697 360.953 375.475 360.632L374.157 358.671C374.057 358.516 373.924 358.405 373.747 358.349C373.581 358.305 373.359 358.327 373.215 358.416C372.916 358.604 372.749 359.047 372.971 359.369Z"
      fill="#E8E8F7"
    />
    <path
      d="M373.304 365.906C374.19 371.336 376.107 376.555 378.944 381.264C379.398 382.029 380.595 381.33 380.14 380.566C377.37 375.945 375.509 370.859 374.644 365.541C374.5 364.665 373.171 365.031 373.304 365.906Z"
      fill="#E8E8F7"
    />
    <path
      d="M381.381 344C383.996 345.241 386.445 346.825 388.639 348.731C389.315 349.307 390.29 348.332 389.614 347.756C387.332 345.784 384.805 344.11 382.079 342.814C381.747 342.659 381.337 342.725 381.127 343.058C380.949 343.357 381.038 343.845 381.37 344.011L381.381 344Z"
      fill="#E8E8F7"
    />
    <path
      d="M391.62 355.923C388.096 357.507 384.285 359.435 382.811 363.258C382.678 363.613 382.955 364.023 383.298 364.111C383.686 364.222 384.019 363.978 384.152 363.624C385.47 360.211 389.215 358.516 392.329 357.119C392.673 356.964 392.75 356.466 392.573 356.167C392.362 355.812 391.963 355.768 391.62 355.923Z"
      fill="#E8E8F7"
    />
    <path
      d="M333.601 322.083L323.883 326.714C321.512 327.845 318.709 327.523 316.637 325.883L310.077 320.675C310.077 320.675 302.863 317.296 298.996 317.373C298.996 317.373 291.838 318.615 290.918 313.673C290.054 309.063 289.611 300.343 288.691 295.268C287.705 289.86 281.887 281.162 280.17 278.215C278.729 275.755 279.117 273.25 280.48 271.433C282.242 269.073 287.35 262.336 289.755 256.231C292.026 250.469 294.874 241.881 295.14 234.712C295.24 231.887 295.572 228.629 298.63 228.186C301.689 227.742 314.243 226.557 319.983 223.753C328.659 219.521 334.266 215.565 338.344 210.08C342.421 204.584 346.056 202.811 351.729 208.296C357.403 213.792 360.727 219.521 368.45 223.288C376.34 227.133 384.739 228.485 389.98 228.042C391.808 227.886 393.271 228.44 394.39 229.227C396.252 230.535 397.36 232.707 397.548 235C397.847 238.657 399.199 246.07 400.163 250.103C401.482 255.61 404.906 264.829 408.463 267.732C411.31 270.059 412.219 271.433 411.809 275.023C411.41 278.558 405.914 287.4 404.008 292.209C402.147 296.896 401.482 306.104 401.526 311.545C401.57 315.889 400.606 319.512 396.196 318.747C390.379 317.739 385.714 318.725 381.813 322.548C376.506 327.756 375.01 329.429 371.043 328.72C367.076 328.011 359.408 321.784 359.408 321.784L333.601 322.083Z"
      fill="#533FD7"
    />
    <path
      d="M395.698 296.054C395.698 282.469 389.238 282.115 388.828 274.89C387.354 248.829 387.044 224.806 344.959 227.942C306.043 223.354 299.306 243.189 299.705 275.389C299.805 283.533 294.575 284.01 293.467 293.517C291.494 310.459 301.511 326.061 340.017 327.634C380.827 329.307 395.687 313.506 395.687 296.054H395.698Z"
      fill="#CCCCF2"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M321.764 241.56C325.242 240.14 327.46 237.513 326.717 235.695C325.974 233.876 322.552 233.554 319.073 234.975C315.595 236.396 313.377 239.022 314.12 240.841C314.863 242.659 318.285 242.981 321.764 241.56Z"
      fill="#533FD7"
    />
    <path
      d="M381.596 245.492C382.655 243.837 380.656 240.666 377.131 238.409C373.606 236.152 369.889 235.664 368.83 237.318C367.771 238.972 369.77 242.143 373.295 244.4C376.82 246.657 380.537 247.146 381.596 245.492Z"
      fill="#533FD7"
    />
    <path
      d="M335.784 291.279C336.992 290.204 338.355 289.207 340.039 288.83C341.834 288.475 343.419 289.672 344.782 289.65C346.388 289.583 347.773 288.697 349.358 288.342C351.208 288.01 352.594 289.395 353.923 290.459L353.868 290.558C353.081 290.304 352.339 289.982 351.585 289.65C350.544 289.151 349.535 289.328 348.505 289.816C347.297 290.248 346.1 290.569 344.771 290.547C343.031 290.437 341.79 289.184 340.106 289.395C338.576 289.583 337.114 290.425 335.839 291.378L335.762 291.29L335.784 291.279Z"
      fill="#6D6E71"
    />
    <path
      d="M340.05 285.761C340.371 287.09 341.457 287.279 342.144 287.301C343.175 287.323 344.117 286.836 345.302 286.769C346.909 286.669 347.142 287.456 348.35 287.29C349.336 287.146 350.4 286.691 350.123 283.888C349.956 282.182 349.557 280.52 348.848 278.758C348.228 277.206 346.444 273.771 344.759 273.771C343.075 273.771 341.158 277.118 340.582 279.079C339.984 281.085 339.529 283.655 340.05 285.783V285.761Z"
      fill="white"
      stroke="#6D6E71"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M340.759 292.852C341.714 292.852 342.488 292.51 342.488 292.088C342.488 291.666 341.714 291.323 340.759 291.323C339.805 291.323 339.031 291.666 339.031 292.088C339.031 292.51 339.805 292.852 340.759 292.852Z"
      fill="black"
    />
    <path
      d="M349.535 292.498C350.441 292.498 351.175 292.146 351.175 291.712C351.175 291.277 350.441 290.925 349.535 290.925C348.63 290.925 347.895 291.277 347.895 291.712C347.895 292.146 348.63 292.498 349.535 292.498Z"
      fill="black"
    />
    <path
      d="M320.559 287.033C325.559 287.033 329.612 282.98 329.612 277.981C329.612 272.981 325.559 268.928 320.559 268.928C315.559 268.928 311.506 272.981 311.506 277.981C311.506 282.98 315.559 287.033 320.559 287.033Z"
      fill="black"
      stroke="black"
      strokeMiterlimit={10}
    />
    <path
      d="M322.842 277.671C324.102 277.671 325.124 276.649 325.124 275.388C325.124 274.127 324.102 273.105 322.842 273.105C321.581 273.105 320.559 274.127 320.559 275.388C320.559 276.649 321.581 277.671 322.842 277.671Z"
      fill="white"
    />
    <path
      d="M325.102 282.336C325.72 282.336 326.221 281.835 326.221 281.217C326.221 280.599 325.72 280.098 325.102 280.098C324.484 280.098 323.983 280.599 323.983 281.217C323.983 281.835 324.484 282.336 325.102 282.336Z"
      fill="white"
    />
    <path
      d="M309.523 290.347C315.362 287.167 323.484 285.272 329.302 289.494L329.246 289.594C325.978 288.63 322.775 288.02 319.373 288.098C316.016 288.131 312.492 289.339 309.523 290.358V290.347Z"
      fill="black"
    />
    <path
      d="M368.472 287.033C373.472 287.033 377.525 282.98 377.525 277.981C377.525 272.981 373.472 268.928 368.472 268.928C363.472 268.928 359.419 272.981 359.419 277.981C359.419 282.98 363.472 287.033 368.472 287.033Z"
      fill="black"
      stroke="black"
      strokeMiterlimit={10}
    />
    <path
      d="M366.19 277.671C367.45 277.671 368.472 276.649 368.472 275.388C368.472 274.127 367.45 273.105 366.19 273.105C364.929 273.105 363.907 274.127 363.907 275.388C363.907 276.649 364.929 277.671 366.19 277.671Z"
      fill="white"
    />
    <path
      d="M363.929 282.336C364.547 282.336 365.048 281.835 365.048 281.217C365.048 280.599 364.547 280.098 363.929 280.098C363.311 280.098 362.81 280.599 362.81 281.217C362.81 281.835 363.311 282.336 363.929 282.336Z"
      fill="white"
    />
    <path
      d="M380.927 290.037C374.123 287.522 366.777 287.666 359.785 289.306L359.741 289.206C362.91 287.289 366.788 286.758 370.434 287.19C373.968 287.578 378.035 288.342 380.927 290.037Z"
      fill="black"
    />
    <path
      d="M333.114 234.124C340.848 231.908 349.291 232.539 356.948 234.733C357.802 234.977 358.178 233.648 357.314 233.393C349.424 231.143 340.704 230.501 332.737 232.783C331.884 233.027 332.249 234.368 333.103 234.124H333.114Z"
      fill="#E8E8F7"
    />
    <path
      d="M361.669 235.942C362.555 235.942 362.566 234.557 361.669 234.557C360.771 234.557 360.771 235.942 361.669 235.942Z"
      fill="#E8E8F7"
    />
    <path
      d="M327.352 445.354C327.23 447.415 325.667 447.26 323.329 447.271C321.013 447.282 319.429 447.216 319.562 445.155C319.684 443.094 321.545 439.348 323.861 439.492C326.177 439.636 327.473 443.282 327.352 445.343V445.354Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M317.024 444.446C316.271 446.186 315.229 445.665 313.578 445.111C311.927 444.557 310.852 444.125 311.606 442.385C312.359 440.646 314.864 437.898 316.448 438.574C318.033 439.261 317.778 442.707 317.024 444.435V444.446Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M363.708 445.376C363.829 447.437 365.392 447.282 367.73 447.293C370.068 447.304 371.63 447.238 371.497 445.177C371.364 443.116 369.514 439.371 367.198 439.515C364.882 439.659 363.586 443.304 363.708 445.365V445.376Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M374.046 444.612C374.799 446.352 375.841 445.831 377.492 445.277C379.121 444.723 380.218 444.291 379.464 442.551C378.711 440.812 376.207 438.064 374.622 438.74C373.038 439.427 373.292 442.873 374.046 444.601V444.612Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M380.373 372.477C379.464 373.075 379.919 373.696 380.473 374.693C381.027 375.69 381.437 376.333 382.345 375.734C383.254 375.136 384.506 373.352 383.875 372.41C383.243 371.468 381.271 371.878 380.362 372.477H380.373Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      opacity={0.25}
      d="M302.63 246.945C302.63 246.945 302.819 273.217 304.171 277.516C305.523 281.815 303.196 285.261 302.287 286.824C299.417 291.755 295.55 304.121 311.406 316.631C321.778 324.819 333.812 327.002 333.812 327.002C333.812 327.002 319.429 326.238 308.625 320.686C305.744 319.201 294.464 314.426 293.378 298.37C292.946 291.987 295.173 286.137 297.157 283.455C299.14 280.774 299.539 277.97 299.339 271.366C298.785 253.006 302.642 246.934 302.642 246.934L302.63 246.945Z"
      fill="#533FD7"
    />
    <path
      opacity={0.25}
      d="M383.775 245.394C383.775 245.394 386.179 271.666 384.827 275.965C383.476 280.264 385.803 283.71 386.711 285.273C389.581 290.204 393.448 302.57 377.592 315.08C367.22 323.268 354.721 326.714 354.721 326.714C354.721 326.714 367.619 327.279 378.412 321.717C381.293 320.232 394.989 312.974 396.063 296.918C396.495 290.536 393.814 284.586 391.83 281.904C389.747 279.09 388.152 277.206 388.362 270.602C388.916 252.241 383.764 245.394 383.764 245.394H383.775Z"
      fill="#533FD7"
    />
    <path
      opacity={0.25}
      d="M384.484 337.961C384.484 337.961 396.241 350.283 397.77 355.136C398.557 357.629 398.712 361.341 397.77 365.718C396.218 372.942 384.794 380.754 384.794 380.754L386.346 382.139C387.542 382.649 390.977 382.571 391.963 381.729C395.077 379.081 402.102 371.901 402.08 363.712C402.058 357.773 401.504 353.839 392.994 345.318C387.642 339.955 383.764 336.897 384.484 337.961Z"
      fill="#533FD7"
    />
    <path
      d="M383.609 377.719C382.667 378.827 383.476 379.459 384.573 380.522C385.67 381.586 386.434 382.262 387.365 381.154C388.296 380.046 389.238 377.287 388.085 376.312C386.933 375.337 384.55 376.6 383.609 377.719Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      opacity={0.25}
      d="M325.18 394.04C325.18 394.04 334.853 401.963 345.291 401.819C356.04 401.675 363.663 394.04 363.663 394.04C363.663 394.04 357.17 405.863 344.881 406.195C333.202 406.517 325.169 394.04 325.169 394.04H325.18Z"
      fill="#533FD7"
    />
    <path
      opacity={0.25}
      d="M328.615 407.348C328.615 407.348 331.972 409.01 334.133 415.237C334.842 417.276 334.776 425.564 335.241 427.293C336.526 432.069 334.432 441.121 334.432 441.121L334.055 445.808C334.055 445.808 338.233 446.695 338.676 444.579C339.806 439.282 340.194 434.473 338.1 426.672C336.682 421.387 337.036 414.384 337.036 414.384L333.546 410.949C333.546 410.949 338.909 414.982 344.782 414.982C350.643 414.982 356.97 411.315 356.97 411.315L353.779 414.384C353.779 414.384 353.103 423.581 352.804 425.509C352.527 427.271 351.707 428.899 351.408 431.725C351.197 433.686 351.064 437.786 351.353 441.188C351.685 445.232 353.325 445.664 354.167 446.141C356.283 447.315 359.818 447.293 359.818 447.293L358.034 439.515C358.034 439.515 354.832 435.902 355.707 428.955C356.051 426.273 357.214 422.883 356.948 420.655C356.682 418.428 356.162 415.592 356.572 414.794C357.713 412.611 361.68 407.891 361.68 407.891C361.68 407.891 351.851 413.087 344.981 412.954C339.263 412.844 332.571 410.472 328.626 407.348H328.615Z"
      fill="#533FD7"
    />
    <path
      d="M336.892 444.191C337.158 446.23 335.607 446.385 333.324 446.839C331.064 447.293 329.501 447.537 329.224 445.487C328.947 443.437 330.066 439.426 332.349 439.116C334.632 438.806 336.615 442.141 336.881 444.18L336.892 444.191Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M354.178 444.368C353.912 446.406 355.463 446.562 357.746 447.016C360.007 447.47 361.569 447.714 361.846 445.664C362.123 443.614 361.004 439.603 358.721 439.293C356.439 438.982 354.455 442.318 354.189 444.357L354.178 444.368Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      opacity={0.3}
      d="M322.605 302.33C323.4 298.47 318.972 294.296 312.714 293.007C306.457 291.718 300.739 293.802 299.944 297.662C299.149 301.522 303.577 305.696 309.835 306.985C316.092 308.274 321.81 306.19 322.605 302.33Z"
      fill="#FF4C37"
    />
    <path
      opacity={0.3}
      d="M378.687 307.025C384.991 305.983 389.58 301.987 388.938 298.099C388.296 294.21 382.665 291.902 376.361 292.944C370.058 293.985 365.468 297.981 366.111 301.87C366.753 305.758 372.384 308.066 378.687 307.025Z"
      fill="#FF4C37"
    />
    <path
      d="M344.383 209.902V221.814C344.383 223.598 347.153 223.598 347.153 221.814V209.902C347.153 208.118 344.383 208.118 344.383 209.902Z"
      fill="#3E2FA0"
    />
    <path
      d="M297.711 234.125C299.628 235.798 301.822 237.072 304.237 237.892C304.924 238.125 305.777 237.626 305.944 236.928C306.121 236.164 305.711 235.477 304.98 235.222C304.725 235.133 304.47 235.045 304.215 234.945C304.148 234.923 304.093 234.889 304.027 234.867C303.716 234.745 304.215 234.945 304.027 234.867C303.905 234.812 303.783 234.756 303.661 234.701C303.151 234.468 302.664 234.213 302.176 233.936C301.689 233.659 301.256 233.371 300.813 233.061C300.702 232.984 300.592 232.906 300.481 232.828C300.448 232.806 300.215 232.629 300.381 232.751C300.525 232.873 300.348 232.729 300.326 232.706C300.104 232.529 299.882 232.341 299.672 232.152C299.129 231.676 298.242 231.576 297.711 232.152C297.234 232.673 297.123 233.604 297.711 234.114V234.125Z"
      fill="#3E2FA0"
    />
    <path
      d="M282.608 276.541C286.807 276.64 291.007 276.197 295.096 275.244C296.835 274.845 296.093 272.175 294.364 272.574C290.508 273.471 286.563 273.859 282.608 273.77C280.824 273.726 280.824 276.496 282.608 276.541Z"
      fill="#3E2FA0"
    />
    <path
      d="M392.241 231.056C390.013 232.673 387.897 234.424 385.913 236.341C385.393 236.84 385.37 237.804 385.913 238.302C386.456 238.801 387.31 238.834 387.875 238.302C388.805 237.405 389.769 236.529 390.767 235.698C391.254 235.288 391.753 234.889 392.252 234.491C392.307 234.446 392.373 234.402 392.429 234.347C392.595 234.225 392.252 234.479 392.418 234.347C392.551 234.247 392.684 234.136 392.817 234.036C393.083 233.837 393.36 233.637 393.637 233.438C394.224 233.017 394.567 232.219 394.135 231.543C393.759 230.967 392.872 230.59 392.241 231.045V231.056Z"
      fill="#3E2FA0"
    />
    <path
      d="M406.845 273.04C402.269 273.161 397.681 272.984 393.127 272.497C392.385 272.419 391.742 273.195 391.742 273.882C391.742 274.702 392.385 275.189 393.127 275.267C397.681 275.754 402.269 275.943 406.845 275.81C408.629 275.765 408.629 272.995 406.845 273.04Z"
      fill="#3E2FA0"
    />
    <path
      d="M397.46 313.76C396.706 312.863 395.842 312.098 394.9 311.411C394.745 311.312 394.567 311.256 394.39 311.245C394.202 311.201 394.024 311.212 393.836 311.267C393.515 311.356 393.171 311.6 393.005 311.899C392.839 312.22 392.75 312.608 392.861 312.963L393.005 313.295C393.127 313.506 393.293 313.672 393.504 313.794C393.603 313.86 393.703 313.938 393.792 314.015L393.515 313.794C394.246 314.359 394.911 315.001 395.498 315.711C395.709 315.965 396.152 316.121 396.473 316.121C396.817 316.121 397.216 315.965 397.448 315.711C397.681 315.456 397.87 315.101 397.858 314.736L397.814 314.37C397.748 314.137 397.626 313.927 397.46 313.76Z"
      fill="#3E2FA0"
    />
    <path
      d="M295.749 315.456C295.849 315.323 295.971 315.212 296.104 315.102L295.827 315.323C295.971 315.212 296.137 315.113 296.303 315.046L295.971 315.19C296.148 315.124 296.325 315.068 296.503 315.046L296.137 315.091C296.281 315.068 296.436 315.068 296.58 315.091C296.769 315.091 296.946 315.057 297.112 314.969C297.278 314.913 297.434 314.813 297.555 314.681C297.688 314.559 297.788 314.404 297.844 314.237C297.932 314.071 297.965 313.894 297.965 313.705C297.954 313.351 297.832 312.974 297.555 312.73L297.278 312.509C297.068 312.387 296.824 312.32 296.58 312.32C296.292 312.298 296.004 312.343 295.716 312.387C295.428 312.431 295.162 312.553 294.896 312.664C294.73 312.73 294.586 312.819 294.442 312.93C294.209 313.107 293.976 313.273 293.799 313.506C293.666 313.628 293.566 313.783 293.511 313.949C293.422 314.115 293.389 314.293 293.389 314.481C293.389 314.669 293.422 314.847 293.511 315.013C293.566 315.179 293.666 315.334 293.799 315.456C294.065 315.7 294.409 315.877 294.774 315.866L295.14 315.822C295.373 315.755 295.583 315.633 295.749 315.467V315.456Z"
      fill="#3E2FA0"
    />
    <path
      d="M332.537 305.119C339.274 310.293 347.707 311.069 354.643 305.905C355.098 305.606 355.53 305.296 356.006 305.008L356.084 305.085C353.336 308.576 348.87 310.814 344.361 310.36C340.072 310.061 335.374 308.066 332.537 305.119Z"
      fill="#231F20"
    />
    <path
      d="M320.393 239.121L321.08 238.634L311.916 224.151L310.564 224.672L320.393 239.121Z"
      fill="#D1D3D4"
    />
    <path
      d="M309.223 226.346C311.775 226.346 313.844 224.277 313.844 221.725C313.844 219.173 311.775 217.104 309.223 217.104C306.672 217.104 304.603 219.173 304.603 221.725C304.603 224.277 306.672 226.346 309.223 226.346Z"
      fill="#E6E7E8"
      stroke="#F1F2F2"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      opacity={0.4}
      d="M279.625 346.732C281.771 344.365 282.242 341.297 280.678 339.879C279.114 338.461 276.107 339.23 273.961 341.596C271.815 343.962 271.343 347.031 272.907 348.449C274.472 349.867 277.479 349.098 279.625 346.732Z"
      fill="#FF4C37"
    />
    <path
      opacity={0.25}
      d="M287.417 360.1C292.303 362.394 294.253 362.804 303.672 357.264C312.67 351.978 321.213 346.36 321.213 346.36C321.213 346.36 309.578 356.289 302.675 362.394C297.999 366.538 294.165 366.804 292.658 366.793C285.411 366.749 269.577 354.239 268.679 350.194C268.679 350.194 279.272 356.289 287.417 360.1Z"
      fill="#533FD7"
    />
    <path
      d="M283.018 339.479C282.929 339.501 282.851 339.546 282.785 339.601C282.707 339.645 282.652 339.712 282.608 339.8C282.552 339.878 282.53 339.967 282.53 340.055C282.508 340.144 282.519 340.244 282.541 340.332L282.608 340.498C282.674 340.598 282.752 340.687 282.851 340.742L283.018 340.809C283.139 340.842 283.261 340.842 283.383 340.809C283.472 340.787 283.549 340.742 283.616 340.687C283.693 340.643 283.749 340.576 283.793 340.487C283.849 340.41 283.871 340.321 283.871 340.233C283.893 340.144 283.882 340.044 283.86 339.956L283.793 339.789C283.727 339.69 283.649 339.601 283.549 339.546L283.383 339.479C283.261 339.446 283.139 339.446 283.018 339.479Z"
      fill="#E8E8F7"
    />
    <path
      d="M284.547 342.481C285.489 343.711 286.441 344.93 287.55 346.016C288.768 347.213 290.12 348.276 291.461 349.351C291.749 349.584 292.159 349.639 292.436 349.351C292.68 349.107 292.735 348.609 292.436 348.376C291.118 347.324 289.788 346.282 288.58 345.096C287.538 344.077 286.619 342.947 285.743 341.783C285.522 341.484 285.145 341.329 284.79 341.539C284.502 341.706 284.314 342.193 284.547 342.492V342.481Z"
      fill="#E8E8F7"
    />
    <path
      opacity={0.79}
      d="M275.284 347.259C275.764 346.595 275.731 345.751 275.211 345.374C274.69 344.998 273.878 345.232 273.398 345.896C272.917 346.561 272.95 347.405 273.471 347.781C273.992 348.158 274.803 347.924 275.284 347.259Z"
      fill="white"
    />
    <path
      d="M374.899 241.848L374.212 241.361L383.376 226.867L384.728 227.388L374.899 241.848Z"
      fill="#D1D3D4"
    />
    <path
      d="M386.069 229.072C388.62 229.072 390.689 227.004 390.689 224.452C390.689 221.9 388.62 219.831 386.069 219.831C383.517 219.831 381.448 221.9 381.448 224.452C381.448 227.004 383.517 229.072 386.069 229.072Z"
      fill="#E6E7E8"
      stroke="#F1F2F2"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M408.108 379.304L385.481 389.909L351.774 342.639L331.795 359.016C330.354 360.201 328.338 360.423 326.676 359.57L320.293 356.212C318.542 355.315 316.426 355.514 314.864 356.711L301.101 368.412C298.819 370.163 295.561 369.775 293.766 367.537L287.827 360.146L283.139 363.614C283.139 363.614 281.311 409.61 295.306 433.921C308.237 456.392 320.26 462.885 331.928 464.559C342.333 466.055 357.646 467.207 373.038 460.038C390.146 452.082 402.191 425.123 404.906 411.039C407.942 395.249 408.108 379.304 408.108 379.304Z"
      fill="#F8DBAE"
      stroke="#895B3D"
      strokeWidth={0.75}
      strokeMiterlimit={10}
    />
    <path
      d="M402.89 409.173C404.228 404.102 402.492 399.247 399.013 398.329C395.534 397.411 391.629 400.777 390.291 405.848C388.953 410.919 390.689 415.774 394.168 416.692C397.647 417.61 401.553 414.244 402.89 409.173Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M393.784 432.376C395.625 425.399 393.237 418.72 388.45 417.457C383.663 416.194 378.29 420.825 376.449 427.802C374.608 434.778 376.997 441.457 381.784 442.72C386.571 443.983 391.944 439.352 393.784 432.376Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M383.38 411.428C384.299 407.942 383.107 404.606 380.716 403.975C378.326 403.344 375.642 405.658 374.723 409.144C373.803 412.629 374.996 415.965 377.386 416.596C379.777 417.227 382.46 414.913 383.38 411.428Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M349.79 350.806C358.433 365.41 369.126 378.884 380.196 391.704C381.359 393.056 383.32 391.084 382.157 389.743C371.231 377.1 360.705 363.803 352.184 349.399C351.275 347.869 348.882 349.254 349.79 350.795V350.806Z"
      fill="#C88758"
    />
    <path
      d="M327.997 459.681C329.382 458.153 328.701 455.278 326.475 453.26C324.249 451.241 321.321 450.844 319.936 452.371C318.551 453.899 319.232 456.774 321.458 458.792C323.684 460.811 326.612 461.208 327.997 459.681Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M295.959 394.991C300.107 394.431 302.808 389.075 301.992 383.029C301.175 376.983 297.151 372.535 293.002 373.095C288.854 373.655 286.153 379.011 286.97 385.057C287.786 391.104 291.811 395.551 295.959 394.991Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      opacity={0.25}
      d="M406.834 384.303C406.834 384.303 388.894 436.138 376.273 445.523C362.455 455.817 351.696 457.623 344.017 459.03C336.338 460.438 322 460.67 322 460.67C330.964 465.169 358.267 467.042 374.921 457.723C384.683 452.26 398.379 432.736 401.969 421.434C406.324 407.716 406.834 384.314 406.834 384.314V384.303Z"
      fill="#C88758"
      stroke="#C88758"
      strokeMiterlimit={10}
    />
    <path
      d="M313.744 448.712C314.439 447.946 314.098 446.505 312.983 445.494C311.868 444.483 310.401 444.284 309.706 445.05C309.011 445.816 309.352 447.257 310.467 448.268C311.582 449.28 313.05 449.478 313.744 448.712Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <path
      d="M388.152 402.076C388.351 400.584 387.681 399.263 386.656 399.127C385.631 398.99 384.638 400.089 384.439 401.581C384.241 403.074 384.91 404.394 385.936 404.531C386.961 404.667 387.953 403.568 388.152 402.076Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <path
      d="M321.418 448.666C322.113 447.9 321.772 446.459 320.657 445.448C319.542 444.437 318.074 444.238 317.38 445.004C316.685 445.771 317.026 447.211 318.141 448.223C319.256 449.234 320.724 449.432 321.418 448.666Z"
      fill="#F1F2F2"
      stroke="#F1F2F2"
      strokeMiterlimit={10}
    />
    <g clipPath="url(#clip0_0_1)">
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M256.786 225.441V212.844C256.786 210.285 255.766 207.872 253.915 206.05C252.065 204.228 249.614 203.225 247.014 203.225H176.452C173.853 203.225 171.401 204.228 169.551 206.05C167.701 207.872 166.681 210.285 166.681 212.844V225.441C166.681 228 167.701 230.413 169.551 232.235C171.401 234.057 173.853 235.061 176.452 235.061H240.81C243.18 237.463 247.785 240.029 252.669 241.661C252.803 241.704 252.94 241.726 253.081 241.726C253.511 241.726 253.923 241.5 254.149 241.139C254.371 240.781 254.39 240.343 254.197 239.967C253.207 238.039 252.48 235.929 252.035 233.681C254.98 231.936 256.789 228.826 256.789 225.438L256.786 225.441Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M241.501 232.755L241.427 232.675H241.318H175.243C170.401 232.675 166.445 228.775 166.445 224.018V211.42C166.445 206.663 170.401 202.763 175.243 202.763H245.805C250.647 202.763 254.604 206.663 254.604 211.42V224.018C254.604 227.325 252.695 230.214 249.902 231.67L249.76 231.744L249.768 231.904C249.917 234.975 251.024 236.984 251.778 238.354C251.902 238.58 252.017 238.789 252.117 238.982C252.167 239.08 252.146 239.18 252.077 239.254C252.006 239.33 251.893 239.37 251.77 239.328L251.77 239.328C246.922 237.705 243.682 235.096 241.501 232.755Z"
        fill="#CCCCF2"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M200.43 206.568H172.781C171.988 206.568 171.346 207.201 171.346 207.981V207.985C171.346 208.765 171.988 209.397 172.781 209.397H200.43C201.223 209.397 201.865 208.765 201.865 207.985V207.981C201.865 207.201 201.223 206.568 200.43 206.568Z"
        fill="white"
      />
      <path
        d="M201.954 219.564H172.796C171.998 219.564 171.346 219.148 171.346 218.64C171.346 218.133 171.998 217.717 172.796 217.717H201.954C202.752 217.717 203.404 218.133 203.404 218.64C203.404 219.148 202.752 219.564 201.954 219.564Z"
        fill="white"
      />
      <path
        d="M172.284 222.083H189.22C189.735 222.083 190.158 222.496 190.158 223.007C190.158 223.514 189.739 223.93 189.22 223.93H172.284C171.769 223.93 171.346 223.518 171.346 223.007C171.346 222.499 171.765 222.083 172.284 222.083Z"
        fill="white"
      />
      <path
        d="M223.311 222.083H195.595C195.076 222.083 194.656 222.496 194.656 223.005C194.656 223.514 195.076 223.927 195.595 223.927H223.311C223.829 223.927 224.249 223.514 224.249 223.005C224.249 222.496 223.829 222.083 223.311 222.083Z"
        fill="white"
      />
      <path
        d="M247.9 219.564H209.668C208.87 219.564 208.218 219.148 208.218 218.64C208.218 218.133 208.87 217.717 209.668 217.717H247.9C248.698 217.717 249.35 218.133 249.35 218.64C249.35 219.148 248.698 219.564 247.9 219.564Z"
        fill="white"
      />
      <path
        d="M201.954 228.289H172.796C171.998 228.289 171.346 227.872 171.346 227.365C171.346 226.858 171.998 226.441 172.796 226.441H201.954C202.752 226.441 203.404 226.858 203.404 227.365C203.404 227.872 202.752 228.289 201.954 228.289Z"
        fill="white"
      />
      <path
        d="M247.9 228.289H209.668C208.87 228.289 208.218 227.872 208.218 227.365C208.218 226.858 208.87 226.441 209.668 226.441H247.9C248.698 226.441 249.35 226.858 249.35 227.365C249.35 227.872 248.698 228.289 247.9 228.289Z"
        fill="white"
      />
      <path
        d="M207.083 206.568H226.604C227.397 206.568 228.039 207.204 228.039 207.981C228.039 208.762 227.393 209.394 226.604 209.394H207.083C206.289 209.394 205.648 208.759 205.648 207.981C205.648 207.2 206.293 206.568 207.083 206.568Z"
        fill="white"
      />
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M283.999 117.284V104.369C283.999 101.744 282.954 99.2727 281.059 97.4036C279.16 95.5346 276.65 94.5088 273.983 94.5088H167.376C164.71 94.5088 162.2 95.5382 160.301 97.4036C158.402 99.2727 157.36 101.744 157.36 104.369V117.284C157.36 119.909 158.406 122.38 160.301 124.249C162.2 126.118 164.71 127.144 167.376 127.144H267.623C270.052 129.605 274.773 132.237 279.779 133.912C279.917 133.96 280.058 133.982 280.202 133.982C280.643 133.982 281.062 133.752 281.296 133.379C281.526 133.014 281.545 132.565 281.344 132.178C280.332 130.203 279.587 128.039 279.127 125.735C282.145 123.95 283.999 120.759 283.999 117.284Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M281.773 102.905V115.225L281.769 115.221V115.817C281.769 119.208 279.813 122.17 276.949 123.667L276.807 123.741L276.815 123.9C276.967 127.046 278.099 129.101 278.873 130.505C279.001 130.738 279.12 130.953 279.223 131.153C279.319 131.342 279.135 131.61 278.861 131.518L278.861 131.518C273.891 129.858 270.569 127.18 268.333 124.78L268.259 124.701H268.15H166.141C161.173 124.701 157.117 120.698 157.117 115.821V102.905C157.117 98.024 161.177 94.0254 166.141 94.0254H272.748C277.717 94.0254 281.773 98.0275 281.773 102.905Z"
        fill="#CCCCF2"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M205.046 99.2109H164.387C163.595 99.2109 162.952 99.8434 162.952 100.624V100.627C162.952 101.408 163.595 102.04 164.387 102.04H205.046C205.838 102.04 206.481 101.408 206.481 100.627V100.624C206.481 99.8434 205.838 99.2109 205.046 99.2109Z"
        fill="white"
      />
      <path
        d="M204.512 112.203H164.918C163.835 112.203 162.949 111.786 162.949 111.279C162.949 110.772 163.835 110.355 164.918 110.355H204.512C205.594 110.355 206.481 110.772 206.481 111.279C206.481 111.786 205.594 112.203 204.512 112.203Z"
        fill="white"
      />
      <path
        d="M163.887 114.726H187.553C188.069 114.726 188.492 115.138 188.492 115.649C188.492 116.157 188.073 116.573 187.553 116.573H163.887C163.371 116.573 162.949 116.16 162.949 115.649C162.949 115.142 163.368 114.726 163.887 114.726Z"
        fill="white"
      />
      <path
        d="M233.844 114.726H195.541C195.023 114.726 194.603 115.138 194.603 115.647C194.603 116.156 195.023 116.569 195.541 116.569H233.844C234.363 116.569 234.783 116.156 234.783 115.647C234.783 115.138 234.363 114.726 233.844 114.726Z"
        fill="white"
      />
      <path
        d="M266.904 112.203H214.988C213.905 112.203 213.018 111.786 213.018 111.279C213.018 110.772 213.905 110.355 214.988 110.355H266.904C267.987 110.355 268.873 110.772 268.873 111.279C268.873 111.786 267.987 112.203 266.904 112.203Z"
        fill="white"
      />
      <path
        d="M204.512 120.931H164.918C163.835 120.931 162.949 120.515 162.949 120.008C162.949 119.5 163.835 119.084 164.918 119.084H204.512C205.594 119.084 206.481 119.5 206.481 120.008C206.481 120.515 205.594 120.931 204.512 120.931Z"
        fill="white"
      />
      <path
        d="M266.904 120.931H214.988C213.905 120.931 213.018 120.515 213.018 120.008C213.018 119.5 213.905 119.084 214.988 119.084H266.904C267.987 119.084 268.873 119.5 268.873 120.008C268.873 120.515 267.987 120.931 266.904 120.931Z"
        fill="white"
      />
      <path
        d="M213.308 99.2109H242.373C243.167 99.2109 243.809 99.8461 243.809 100.624C243.809 101.405 243.163 102.036 242.373 102.036H213.308C212.514 102.036 211.873 101.401 211.873 100.624C211.873 99.8425 212.518 99.2109 213.308 99.2109Z"
        fill="white"
      />
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M104.62 151.713V138.797C104.62 136.173 105.666 133.701 107.561 131.832C109.46 129.963 111.97 128.938 114.637 128.938H201.285C203.952 128.938 206.462 129.967 208.361 131.832C210.259 133.701 211.301 136.173 211.301 138.797V151.713C211.301 154.338 210.256 156.809 208.361 158.678C206.462 160.547 203.952 161.573 201.285 161.573H120.993C118.564 164.033 113.843 166.665 108.837 168.341C108.7 168.388 108.559 168.41 108.414 168.41C107.973 168.41 107.554 168.18 107.32 167.808C107.09 167.443 107.072 166.994 107.272 166.607C108.284 164.632 109.03 162.467 109.489 160.164C106.471 158.379 104.617 155.188 104.617 151.713H104.62Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M115.871 128.457H201.91L201.907 128.461H202.516C207.485 128.461 211.541 132.463 211.541 137.341V150.256C211.541 155.137 207.481 159.136 202.516 159.136H120.466H120.357L120.283 159.215C118.047 161.615 114.729 164.29 109.756 165.953C109.626 165.995 109.507 165.953 109.433 165.874C109.361 165.797 109.339 165.693 109.393 165.59L109.393 165.589C109.495 165.39 109.614 165.175 109.742 164.941C110.516 163.537 111.649 161.48 111.801 158.336L111.809 158.176L111.667 158.102C108.803 156.605 106.847 153.643 106.847 150.252V137.337C106.847 132.456 110.907 128.457 115.871 128.457Z"
        fill="white"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M149.376 132.788H114.447C113.655 132.788 113.012 133.421 113.012 134.201V134.405C113.012 135.185 113.655 135.818 114.447 135.818H149.376C150.169 135.818 150.811 135.185 150.811 134.405V134.201C150.811 133.421 150.169 132.788 149.376 132.788Z"
        fill="#D1D3D4"
      />
      <path
        d="M145.655 145.4H119.515C118.802 145.4 118.215 144.955 118.215 144.414C118.215 143.87 118.799 143.429 119.515 143.429H145.655C146.368 143.429 146.954 143.874 146.954 144.414C146.954 144.958 146.371 145.4 145.655 145.4Z"
        fill="#D1D3D4"
      />
      <path
        d="M118.929 148.098H134.368C134.76 148.098 135.082 148.51 135.082 149.021V149.153C135.082 149.66 134.763 150.076 134.368 150.076H118.929C118.537 150.076 118.215 149.664 118.215 149.153V149.021C118.215 148.514 118.534 148.098 118.929 148.098Z"
        fill="#D1D3D4"
      />
      <path
        d="M164.929 148.098H139.827C139.433 148.098 139.113 148.511 139.113 149.021V149.149C139.113 149.659 139.433 150.073 139.827 150.073H164.929C165.323 150.073 165.642 149.659 165.642 149.149V149.021C165.642 148.511 165.323 148.098 164.929 148.098Z"
        fill="#D1D3D4"
      />
      <path
        d="M186.847 145.4H152.574C151.86 145.4 151.274 144.955 151.274 144.414C151.274 143.87 151.858 143.429 152.574 143.429H186.847C187.561 143.429 188.147 143.874 188.147 144.414C188.147 144.958 187.563 145.4 186.847 145.4Z"
        fill="#D1D3D4"
      />
      <path
        d="M145.655 154.746H119.515C118.802 154.746 118.215 154.3 118.215 153.76C118.215 153.216 118.799 152.774 119.515 152.774H145.655C146.368 152.774 146.954 153.22 146.954 153.76C146.954 154.304 146.371 154.746 145.655 154.746Z"
        fill="#D1D3D4"
      />
      <path
        d="M186.847 154.746H152.574C151.86 154.746 151.274 154.3 151.274 153.76C151.274 153.216 151.858 152.774 152.574 152.774H186.847C187.561 152.774 188.147 153.22 188.147 153.76C188.147 154.304 187.563 154.746 186.847 154.746Z"
        fill="#D1D3D4"
      />
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M73.2072 99.5069V86.5914C73.2072 83.9667 74.2529 81.4953 76.1479 79.6263C78.0465 77.7572 80.5571 76.7314 83.2233 76.7314H158.754C161.421 76.7314 163.931 77.7609 165.83 79.6263C167.729 81.4917 168.771 83.9667 168.771 86.5914V99.5069C168.771 102.132 167.725 104.603 165.83 106.472C163.935 108.341 161.421 109.367 158.754 109.367H89.5831C87.1542 111.827 82.4335 114.459 77.4272 116.135C77.29 116.182 77.1491 116.204 77.0045 116.204C76.5632 116.204 76.1441 115.974 75.9105 115.602C75.6806 115.237 75.6621 114.788 75.8623 114.401C76.8747 112.426 77.6201 110.261 78.0799 107.958C75.0613 106.173 73.2072 102.982 73.2072 99.5069Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M80.3914 106.13L80.3992 105.97L80.2575 105.896C77.3939 104.399 75.4374 101.437 75.4374 98.0463V85.1309C75.4374 80.2495 79.4937 76.251 84.4582 76.251H159.989C164.958 76.251 169.014 80.2531 169.014 85.1309V98.0499C169.014 102.931 164.954 106.93 159.989 106.93H89.0565H88.9478L88.8736 107.009C86.6376 109.409 83.3195 112.084 78.3462 113.747C78.217 113.789 78.0977 113.747 78.024 113.668C77.9518 113.591 77.9295 113.487 77.9831 113.384L77.9833 113.383C78.0858 113.184 78.2044 112.969 78.3328 112.735C79.1065 111.331 80.2392 109.274 80.3914 106.13Z"
        fill="white"
        stroke="black"
        strokeWidth={0.5}
      />
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M254.062 169.022V156.106C254.062 153.481 253.017 151.01 251.122 149.141C249.223 147.272 246.712 146.246 244.046 146.246H213.653C210.986 146.246 208.476 147.276 206.577 149.141C204.678 151.01 203.636 153.481 203.636 156.106V169.022C203.636 171.646 204.682 174.118 206.577 175.987C208.476 177.856 210.986 178.881 213.653 178.881H237.686C240.115 181.342 244.836 183.974 249.842 185.65C249.979 185.697 250.12 185.719 250.265 185.719C250.706 185.719 251.125 185.489 251.359 185.117C251.589 184.751 251.607 184.302 251.407 183.916C250.395 181.941 249.649 179.776 249.19 177.472C252.208 175.687 254.062 172.497 254.062 169.022Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M251.832 154.643V166.962L251.828 166.958V167.554C251.828 170.945 249.872 173.908 247.008 175.404L246.867 175.478L246.874 175.638C247.026 178.784 248.158 180.838 248.932 182.242C249.061 182.475 249.179 182.691 249.282 182.89C249.378 183.08 249.194 183.347 248.921 183.255L248.92 183.255C243.95 181.596 240.628 178.918 238.392 176.517L238.318 176.438H238.209H212.414C207.446 176.438 203.39 172.436 203.39 167.558V154.643C203.39 149.761 207.449 145.763 212.414 145.763H242.807C247.776 145.763 251.832 149.765 251.832 154.643Z"
        fill="#FF4C37"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M235.91 158.549C235.91 158.549 235.91 158.52 235.91 158.505C235.91 155.778 233.908 153.281 230.896 153.281C228.504 153.281 227.114 154.975 226.643 156.559C226.168 154.975 224.781 153.281 222.389 153.281C219.378 153.281 217.376 155.778 217.376 158.505C217.376 158.52 217.376 158.534 217.376 158.549C217.361 159.144 217.376 165.178 226.643 170.099C235.91 165.178 235.925 159.14 235.91 158.549Z"
        fill="white"
      />
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <path
          d="M70.6965 209.332V196.417C70.6965 193.792 71.7423 191.321 73.6372 189.451C75.5322 187.582 78.0464 186.557 80.7127 186.557H174.37C177.036 186.557 179.547 187.586 181.446 189.451C183.344 191.321 184.386 193.792 184.386 196.417V209.332C184.386 211.957 183.341 214.428 181.446 216.297C179.547 218.166 177.036 219.192 174.37 219.192H87.0725C84.6435 221.652 79.9228 224.284 74.9166 225.96C74.7794 226.008 74.6385 226.029 74.4939 226.029C74.0526 226.029 73.6335 225.799 73.3999 225.427C73.17 225.062 73.1514 224.613 73.3517 224.226C74.3641 222.251 75.1094 220.086 75.5693 217.783C72.5507 215.998 70.6965 212.807 70.6965 209.332Z"
          fill="#F0F1F1"
        />
      </g>
      <path
        d="M81.9476 186.08H175.6L175.601 186.084C180.57 186.084 184.626 190.086 184.626 194.964V207.879C184.626 212.76 180.566 216.759 175.601 216.759H86.5422H86.4334L86.3593 216.839C84.1232 219.238 80.8052 221.913 75.8319 223.576C75.7026 223.618 75.5833 223.576 75.5096 223.497C75.4375 223.42 75.4151 223.316 75.4687 223.213L75.469 223.212C75.5715 223.013 75.69 222.798 75.8185 222.564C76.5922 221.16 77.7248 219.103 77.8771 215.959L77.8848 215.799L77.7432 215.725C74.8796 214.229 72.9231 211.266 72.9231 207.875V194.96C72.9231 190.079 76.9829 186.08 81.9476 186.08Z"
        fill="white"
        stroke="black"
        strokeWidth={0.5}
      />
      <path
        d="M118.471 190.608H77.8128C77.0202 190.608 76.3777 191.241 76.3777 192.021V192.025C76.3777 192.805 77.0202 193.438 77.8128 193.438H118.471C119.263 193.438 119.906 192.805 119.906 192.025V192.021C119.906 191.241 119.263 190.608 118.471 190.608Z"
        fill="#E6E7E8"
      />
      <path
        d="M117.941 203.604H78.3468C77.264 203.604 76.3777 203.188 76.3777 202.68C76.3777 202.173 77.264 201.757 78.3468 201.757H117.941C119.023 201.757 119.91 202.173 119.91 202.68C119.91 203.188 119.023 203.604 117.941 203.604Z"
        fill="#E6E7E8"
      />
      <path
        d="M77.3159 206.123H100.982C101.498 206.123 101.921 206.536 101.921 207.047C101.921 207.554 101.502 207.97 100.982 207.97H77.3159C76.8004 207.97 76.3777 207.558 76.3777 207.047C76.3777 206.539 76.7967 206.123 77.3159 206.123Z"
        fill="#E6E7E8"
      />
      <path
        d="M147.273 206.123H108.97C108.452 206.123 108.032 206.536 108.032 207.045C108.032 207.554 108.452 207.967 108.97 207.967H147.273C147.792 207.967 148.212 207.554 148.212 207.045C148.212 206.536 147.792 206.123 147.273 206.123Z"
        fill="#E6E7E8"
      />
      <path
        d="M180.329 203.604H128.417C127.334 203.604 126.447 203.188 126.447 202.68C126.447 202.173 127.334 201.757 128.417 201.757H180.333C181.416 201.757 182.302 202.173 182.302 202.68C182.302 203.188 181.416 203.604 180.333 203.604H180.329Z"
        fill="#E6E7E8"
      />
      <path
        d="M117.941 212.329H78.3468C77.264 212.329 76.3777 211.912 76.3777 211.405C76.3777 210.898 77.264 210.481 78.3468 210.481H117.941C119.023 210.481 119.91 210.898 119.91 211.405C119.91 211.912 119.023 212.329 117.941 212.329Z"
        fill="#E6E7E8"
      />
      <path
        d="M180.329 212.329H128.417C127.334 212.329 126.447 211.912 126.447 211.405C126.447 210.898 127.334 210.481 128.417 210.481H180.333C181.416 210.481 182.302 210.898 182.302 211.405C182.302 211.912 181.416 212.329 180.333 212.329H180.329Z"
        fill="#E6E7E8"
      />
      <path
        d="M126.737 190.608H155.803C156.596 190.608 157.238 191.244 157.238 192.021C157.238 192.802 156.592 193.434 155.803 193.434H126.737C125.943 193.434 125.302 192.799 125.302 192.021C125.302 191.24 125.947 190.608 126.737 190.608Z"
        fill="#E6E7E8"
      />
      <path
        d="M113.127 81.3604H82.2369C81.4443 81.3604 80.8018 81.9929 80.8018 82.7731V82.7767C80.8018 83.557 81.4443 84.1895 82.2369 84.1895H113.127C113.92 84.1895 114.562 83.557 114.562 82.7767V82.7731C114.562 81.9929 113.92 81.3604 113.127 81.3604Z"
        fill="#D1D3D4"
      />
      <path
        d="M113.035 94.352H82.3259C81.4878 94.352 80.7981 93.9359 80.7981 93.4285C80.7981 92.921 81.4841 92.5049 82.3259 92.5049H113.035C113.873 92.5049 114.562 92.921 114.562 93.4285C114.562 93.9359 113.876 94.352 113.035 94.352Z"
        fill="#D1D3D4"
      />
      <path
        d="M81.7363 96.875H99.6735C100.189 96.875 100.612 97.2875 100.612 97.7986C100.612 98.306 100.193 98.7221 99.6735 98.7221H81.7363C81.2208 98.7221 80.7981 98.3096 80.7981 97.7986C80.7981 97.2912 81.2171 96.875 81.7363 96.875Z"
        fill="#D1D3D4"
      />
      <path
        d="M135.577 96.875H106.289C105.771 96.875 105.351 97.2877 105.351 97.7967C105.351 98.3058 105.771 98.7185 106.289 98.7185H135.577C136.096 98.7185 136.516 98.3058 136.516 97.7967C136.516 97.2877 136.096 96.875 135.577 96.875Z"
        fill="#D1D3D4"
      />
      <path
        d="M161.424 94.352H121.16C120.321 94.352 119.632 93.9359 119.632 93.4285C119.632 92.921 120.318 92.5049 121.16 92.5049H161.424C162.263 92.5049 162.952 92.921 162.952 93.4285C162.952 93.9359 162.266 94.352 161.424 94.352Z"
        fill="#D1D3D4"
      />
      <path
        d="M113.035 103.081H82.3259C81.4878 103.081 80.7981 102.664 80.7981 102.157C80.7981 101.65 81.4841 101.233 82.3259 101.233H113.035C113.873 101.233 114.562 101.65 114.562 102.157C114.562 102.664 113.876 103.081 113.035 103.081Z"
        fill="#D1D3D4"
      />
      <path
        d="M161.424 103.081H121.16C120.321 103.081 119.632 102.664 119.632 102.157C119.632 101.65 120.318 101.233 121.16 101.233H161.424C162.263 101.233 162.952 101.65 162.952 102.157C162.952 102.664 162.266 103.081 161.424 103.081Z"
        fill="#D1D3D4"
      />
      <path
        d="M120.177 81.3604H142.074C142.868 81.3604 143.51 81.9955 143.51 82.7731C143.51 83.5543 142.864 84.1858 142.074 84.1858H120.177C119.383 84.1858 118.742 83.5506 118.742 82.7731C118.742 81.9919 119.387 81.3604 120.177 81.3604Z"
        fill="#D1D3D4"
      />
    </g>
    {props?.message}
    <defs>
      <filter
        id="filter0_d_0_1"
        x={0}
        y={0}
        width={561.999}
        height={546.006}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={4} dy={7} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_0_1">
        <rect
          width={214}
          height={171}
          fill="white"
          transform="translate(69.9995 76.001)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ComingSoonIcon;